/* WOP - configurateur de tableau personnalise (voir sections/wop-perso-configurateur.liquid) */
(function () {
  'use strict';

  var root = document.querySelector('[data-wopc]');
  if (!root) return;

  // Shopify refuse les envois au-dela d'environ 10 Mo (test du 13/09/2026).
  var MAX_OCTETS = 9.5 * 1024 * 1024;
  // Au-dela de ~16 Mpx, le canvas des iPhone echoue : la photo est reduite avant envoi.
  // 16 Mpx laissent plus de 200 DPI en 40 x 56, donc aucune perte visible a l'impression.
  var MAX_PIXELS = 16000000;
  var DPI_BON = 200;
  var DPI_MIN = 150;
  var DPI_BLOQUANT = 100;
  // Taille de la plaque dans l'apercu : part de la hauteur du mur, selon son grand cote en cm.
  var ECHELLE_MUR = { 42: 0.50, 49: 0.58, 56: 0.66 };
  var ZOOM_MAX = 4;

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var ui = {
    fichier: $('[data-fichier]'), depot: $('[data-depot]'), depotTitre: $('[data-depot-titre]'),
    erreur: $('[data-erreur]'), etape3: $('[data-etape="3"]'), etape4: $('[data-etape="4"]'),
    cadre: $('[data-cadre]'), image: $('[data-image]'), zoom: $('[data-zoom]'), qualite: $('[data-qualite]'),
    plaque: $('[data-plaque]'), apercu: $('[data-apercu]'), legende: $('[data-legende]'),
    retract: $('[data-retract]'), faibleZone: $('[data-faible-zone]'),
    faible: $('[data-faible]'), ajout: $('[data-ajout]'), prixCta: $('[data-prix-cta]'),
    progres: $('[data-progres]'), barre: $('[data-barre]'), progresTexte: $('[data-progres-texte]'),
    erreurEnvoi: $('[data-erreur-envoi]')
  };

  var s = {
    variante: null, formatTexte: '', cm: [30, 42], prix: '', orientation: 'Portrait',
    img: null, url: null, nom: '', natW: 0, natH: 0, k: 1,
    zoom: 1, echelle: 1, x: 0, y: 0, fw: 0, fh: 0, dpi: 0, niveau: null, envoi: false
  };

  // ---------------------------------------------------------------- galerie
  // Fleches, points, glisser au doigt, et defilement automatique toutes les 5 s tant que le
  // client n'interagit pas : pause au survol et au focus, et 12 s apres chaque action.
  (function galerie() {
    var zone = $('[data-galerie]');
    var piste = $('[data-piste]');
    var points = $('[data-points]');
    if (!zone || !piste || !points || piste.children.length < 2) return;
    var total = piste.children.length;
    var courant = 0;
    var survol = false;
    var visible = true;
    var pauseJusqua = 0;
    var DELAI = 5000;
    var PAUSE_APRES_ACTION = 12000;
    var mouvementReduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function marquer(i) {
      Array.prototype.forEach.call(points.children, function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    function aller(i, parClient) {
      courant = (i + total) % total;
      piste.scrollTo({ left: courant * piste.clientWidth, behavior: mouvementReduit ? 'auto' : 'smooth' });
      marquer(courant);
      if (parClient) pauseJusqua = Date.now() + PAUSE_APRES_ACTION;
    }

    Array.prototype.forEach.call(piste.children, function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Visuel ' + (i + 1) + ' sur ' + total);
      b.addEventListener('click', function () { aller(i, true); });
      points.appendChild(b);
    });

    var prec = $('[data-galerie-prec]');
    var suiv = $('[data-galerie-suiv]');
    if (prec) prec.addEventListener('click', function () { aller(courant - 1, true); });
    if (suiv) suiv.addEventListener('click', function () { aller(courant + 1, true); });

    piste.addEventListener('scroll', function () {
      var i = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
      if (i !== courant) { courant = i; marquer(i); }
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) {
      piste.addEventListener(t, function () { pauseJusqua = Date.now() + PAUSE_APRES_ACTION; }, { passive: true });
    });
    zone.addEventListener('mouseenter', function () { survol = true; });
    zone.addEventListener('mouseleave', function () { survol = false; });
    zone.addEventListener('focusin', function () { survol = true; });
    zone.addEventListener('focusout', function () { survol = false; });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { aller(courant + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { aller(courant - 1, true); e.preventDefault(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) { visible = entrees[0].isIntersecting; }).observe(zone);
    }

    marquer(0);
    if (mouvementReduit) return;
    window.setInterval(function () {
      if (survol || !visible || document.hidden || Date.now() < pauseJusqua) return;
      aller(courant + 1, false);
    }, DELAI);
  })();

  // ---------------------------------------------------------------- etape 1
  function lireChoix() {
    var f = root.querySelector('input[name="wopc-format"]:checked') || root.querySelector('input[name="wopc-format"]');
    s.variante = f.value;
    s.formatTexte = f.getAttribute('data-format') || '';
    var m = s.formatTexte.match(/(\d+)\D+(\d+)/);
    s.cm = m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : [30, 42];
    s.prix = f.getAttribute('data-prix') || '';
    s.orientation = root.querySelector('input[name="wopc-orient"]:checked').value;
    ui.prixCta.textContent = s.prix;
  }

  function paysage() { return s.orientation === 'Paysage'; }

  function appliquerFormat() {
    var rTxt = paysage() ? s.cm[1] + ' / ' + s.cm[0] : s.cm[0] + ' / ' + s.cm[1];
    ui.cadre.style.setProperty('--wopc-ratio', rTxt);
    ui.plaque.style.setProperty('--wopc-ratio', rTxt);
    ui.cadre.classList.toggle('is-paysage', paysage());
    ui.plaque.classList.toggle('is-paysage', paysage());
    // Largeur et hauteur posees toutes les deux, en % du mur (4:3) : une hauteur seule
    // n'etait pas resolue, la plaque descendait vers le sol et sortait du mur sur mobile.
    var part = ECHELLE_MUR[Math.max(s.cm[0], s.cm[1])] || 0.58;
    var rp = Math.min(s.cm[0], s.cm[1]) / Math.max(s.cm[0], s.cm[1]);
    ui.plaque.style.setProperty('--wopc-w', (paysage() ? part * 75 : part * 75 * rp).toFixed(2) + '%');
    ui.plaque.style.setProperty('--wopc-h', (paysage() ? part * 100 * rp : part * 100).toFixed(2) + '%');
    var r = paysage() ? s.cm[1] / s.cm[0] : s.cm[0] / s.cm[1];
    ui.apercu.width = paysage() ? 700 : 500;
    ui.apercu.height = Math.round(ui.apercu.width / r);
    ui.legende.textContent = 'Format ' + s.formatTexte + ' cm · ' + s.orientation.toLowerCase();
    if (s.img) mesurerCadre();
  }

  // ---------------------------------------------------------------- etape 2
  function montrerErreur(t) {
    ui.erreur.textContent = t || '';
    ui.erreur.hidden = !t;
  }

  function charger(fichier) {
    montrerErreur('');
    if (!fichier) return;
    if (!/^image\/(jpeg|png)$/i.test(fichier.type)) {
      montrerErreur(/hei[cf]/i.test(fichier.type + ' ' + fichier.name)
        ? "Les photos HEIC ne sont pas lisibles ici. Envoyez-la depuis votre iPhone, qui la convertit automatiquement, ou exportez-la en JPG."
        : 'Format non pris en charge : envoyez une photo JPG ou PNG.');
      return;
    }
    var url = URL.createObjectURL(fichier);
    var img = new Image();
    img.onload = function () {
      if (s.url) URL.revokeObjectURL(s.url);
      s.url = url;
      s.img = img;
      s.nom = fichier.name;
      // Les navigateurs appliquent l'orientation EXIF : les dimensions sont celles vues a l'ecran.
      s.natW = img.naturalWidth;
      s.natH = img.naturalHeight;
      s.k = Math.min(1, Math.sqrt(MAX_PIXELS / (s.natW * s.natH)));
      s.zoom = 1;
      s.fw = 0;
      ui.zoom.value = '1';
      ui.image.src = url;
      ui.depotTitre.textContent = 'Photo chargée : ' + fichier.name;
      ui.etape3.classList.remove('is-locked');
      ui.etape4.classList.remove('is-locked');
      mesurerCadre();
      ui.etape3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      montrerErreur('Impossible de lire cette image. Essayez avec une autre photo au format JPG.');
    };
    img.src = url;
  }

  ui.fichier.addEventListener('change', function () { charger(ui.fichier.files[0]); });
  ['dragenter', 'dragover'].forEach(function (t) {
    ui.depot.addEventListener(t, function (e) { e.preventDefault(); ui.depot.classList.add('is-over'); });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    ui.depot.addEventListener(t, function (e) { e.preventDefault(); ui.depot.classList.remove('is-over'); });
  });
  ui.depot.addEventListener('drop', function (e) {
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) charger(e.dataTransfer.files[0]);
  });

  // ---------------------------------------------------------------- etape 3 : recadrage
  // Coordonnees : l'image affichee mesure natW x natH multiplie par s.echelle, et son coin
  // haut-gauche est en (s.x, s.y) dans le cadre. Elle doit toujours couvrir tout le cadre.
  function couverture() { return Math.max(s.fw / s.natW, s.fh / s.natH); }

  function centreImage() {
    if (!s.fw) return { cx: s.natW / 2, cy: s.natH / 2 };
    return { cx: (s.fw / 2 - s.x) / s.echelle, cy: (s.fh / 2 - s.y) / s.echelle };
  }

  function borner() {
    var dw = s.natW * s.echelle;
    var dh = s.natH * s.echelle;
    s.x = Math.min(0, Math.max(s.fw - dw, s.x));
    s.y = Math.min(0, Math.max(s.fh - dh, s.y));
  }

  function placer(cx, cy) {
    s.echelle = couverture() * s.zoom;
    s.x = s.fw / 2 - cx * s.echelle;
    s.y = s.fh / 2 - cy * s.echelle;
    borner();
    rendre();
  }

  function mesurerCadre() {
    if (!s.img) return;
    var c = centreImage();
    var rect = ui.cadre.getBoundingClientRect();
    s.fw = rect.width;
    s.fh = rect.height;
    placer(c.cx, c.cy);
  }

  function zoomer(z) {
    if (!s.img) return;
    if (!s.fw) mesurerCadre();
    var c = centreImage();
    s.zoom = Math.min(ZOOM_MAX, Math.max(1, z));
    ui.zoom.value = String(s.zoom);
    placer(c.cx, c.cy);
  }

  function recadrage() {
    // Pas de nouvelle mesure ici (mesurerCadre rappelle recadrage) : repli sur l'image entiere.
    if (!s.echelle || !s.fw) return { x: 0, y: 0, w: s.natW, h: s.natH };
    var r = { x: -s.x / s.echelle, y: -s.y / s.echelle, w: s.fw / s.echelle, h: s.fh / s.echelle };
    r.x = Math.max(0, r.x);
    r.y = Math.max(0, r.y);
    r.w = Math.min(s.natW - r.x, r.w);
    r.h = Math.min(s.natH - r.y, r.h);
    return r;
  }

  function rendre() {
    ui.image.style.width = (s.natW * s.echelle) + 'px';
    ui.image.style.height = (s.natH * s.echelle) + 'px';
    ui.image.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px)';
    majQualite();
    majBouton();
    planifierApercu();
  }

  // L'apercu est le seul calcul couteux : on le regroupe par image d'affichage, avec un
  // minuteur en secours car certains navigateurs suspendent requestAnimationFrame.
  var apercuPrevu = false;
  function planifierApercu() {
    if (apercuPrevu) return;
    apercuPrevu = true;
    var fait = false;
    function dessiner() {
      if (fait) return;
      fait = true;
      apercuPrevu = false;
      dessinerApercu();
    }
    window.requestAnimationFrame(dessiner);
    window.setTimeout(dessiner, 120);
  }

  var pointeurs = {};
  var pincement = null;
  ui.cadre.addEventListener('pointerdown', function (e) {
    if (!s.img) return;
    try { ui.cadre.setPointerCapture(e.pointerId); } catch (err) { /* pointeur deja relache */ }
    pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
    pincement = null;
  });
  ui.cadre.addEventListener('pointermove', function (e) {
    var p = pointeurs[e.pointerId];
    if (!p) return;
    var ids = Object.keys(pointeurs);
    if (ids.length === 1) {
      s.x += e.clientX - p.x;
      s.y += e.clientY - p.y;
      p.x = e.clientX;
      p.y = e.clientY;
      borner();
      rendre();
    } else if (ids.length === 2) {
      p.x = e.clientX;
      p.y = e.clientY;
      var a = pointeurs[ids[0]];
      var b = pointeurs[ids[1]];
      var d = Math.hypot(a.x - b.x, a.y - b.y);
      if (!pincement) { pincement = { d: d, zoom: s.zoom }; return; }
      zoomer(pincement.zoom * d / Math.max(1, pincement.d));
    }
  });
  function lacher(e) { delete pointeurs[e.pointerId]; pincement = null; }
  ui.cadre.addEventListener('pointerup', lacher);
  ui.cadre.addEventListener('pointercancel', lacher);
  ui.cadre.addEventListener('wheel', function (e) {
    if (!s.img) return;
    e.preventDefault();
    zoomer(s.zoom * (e.deltaY < 0 ? 1.08 : 1 / 1.08));
  }, { passive: false });
  ui.zoom.addEventListener('input', function () { zoomer(parseFloat(ui.zoom.value)); });
  window.addEventListener('resize', function () { if (s.img) mesurerCadre(); });

  function majQualite() {
    var r = recadrage();
    var largeurCm = paysage() ? s.cm[1] : s.cm[0];
    s.dpi = (r.w * s.k) / (largeurCm / 2.54);
    var niveau;
    var texte;
    if (s.dpi >= DPI_BON) {
      niveau = 'bon';
      texte = 'Excellente netteté pour ce format';
    } else if (s.dpi >= DPI_MIN) {
      niveau = 'moyen';
      texte = 'Bonne netteté pour ce format';
    } else if (s.dpi >= DPI_BLOQUANT) {
      niveau = 'faible';
      texte = 'Photo un peu petite pour ce format : le rendu peut manquer de netteté. Dézoomez ou choisissez un format plus petit.';
    } else {
      niveau = 'bloque';
      texte = 'Photo trop petite pour ce format. Dézoomez, choisissez un format plus petit ou une photo plus grande.';
    }
    s.niveau = niveau;
    ui.qualite.setAttribute('data-niveau', niveau);
    ui.qualite.textContent = texte;
    ui.faibleZone.hidden = niveau !== 'faible';
    if (niveau !== 'faible') ui.faible.checked = false;
  }

  // ---------------------------------------------------------------- etape 4 : apercu et panier
  function dessinerApercu() {
    var r = recadrage();
    var ctx = ui.apercu.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(s.img, r.x, r.y, r.w, r.h, 0, 0, ui.apercu.width, ui.apercu.height);
  }

  function majBouton() {
    ui.ajout.disabled = !(s.img && s.niveau && !s.envoi && ui.retract.checked &&
      s.niveau !== 'bloque' && (s.niveau !== 'faible' || ui.faible.checked));
  }

  $$('input[name="wopc-format"], input[name="wopc-orient"]').forEach(function (i) {
    i.addEventListener('change', function () { lireChoix(); appliquerFormat(); majBouton(); });
  });
  [ui.retract, ui.faible].forEach(function (c) { c.addEventListener('change', majBouton); });

  function encoder(canvas, qualite, fin) {
    canvas.toBlob(function (b) {
      if (b && b.size > MAX_OCTETS && qualite > 0.7) { encoder(canvas, qualite - 0.07, fin); return; }
      fin(b);
    }, 'image/jpeg', qualite);
  }

  // Toujours re-encoder : l'orientation EXIF est ainsi inscrite dans les pixels, et le
  // recadrage transmis correspond exactement au fichier que l'atelier telechargera.
  function preparerPhoto(fin) {
    var w = Math.round(s.natW * s.k);
    var h = Math.round(s.natH * s.k);
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff';   // un PNG transparent s'imprime sur fond blanc
    ctx.fillRect(0, 0, w, h);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(s.img, 0, 0, w, h);
    encoder(c, 0.93, function (b) { fin(b, w, h); });
  }

  function nomJpg(n) {
    return (n || 'photo').replace(/\.[^.]+$/, '').replace(/[^\w-]+/g, '-').slice(0, 60) + '.jpg';
  }

  function echec(t) {
    s.envoi = false;
    ui.progres.hidden = true;
    ui.erreurEnvoi.textContent = t;
    ui.erreurEnvoi.hidden = false;
    majBouton();
  }

  function envoyer(fd) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.upload.onprogress = function (e) {
      if (!e.lengthComputable) return;
      var p = Math.round(e.loaded / e.total * 100);
      ui.barre.style.width = p + '%';
      ui.progresTexte.textContent = 'Envoi de votre photo… ' + p + ' %';
    };
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        ui.progresTexte.textContent = 'Photo reçue, direction le panier…';
        var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = racine + 'cart';
      } else if (xhr.status === 413) {
        echec('Votre photo est trop lourde. Réessayez avec une image plus petite.');
      } else {
        echec("L'ajout au panier a échoué. Réessayez dans un instant.");
      }
    };
    xhr.onerror = function () { echec("L'envoi a été interrompu. Vérifiez votre connexion et réessayez."); };
    xhr.send(fd);
  }

  ui.ajout.addEventListener('click', function () {
    if (ui.ajout.disabled) return;
    s.envoi = true;
    majBouton();
    ui.erreurEnvoi.hidden = true;
    ui.progres.hidden = false;
    ui.barre.style.width = '0%';
    ui.progresTexte.textContent = 'Préparation de votre photo…';
    if (!s.fw) mesurerCadre();
    dessinerApercu();
    var r = recadrage();
    preparerPhoto(function (photo, w, h) {
      if (!photo) { echec('Impossible de préparer la photo. Réessayez avec une autre image.'); return; }
      ui.apercu.toBlob(function (apercu) {
        var cx = Math.max(0, Math.round(r.x * s.k));
        var cy = Math.max(0, Math.round(r.y * s.k));
        var cw = Math.min(w - cx, Math.round(r.w * s.k));
        var ch = Math.min(h - cy, Math.round(r.h * s.k));
        function pct(v, t) { return (v / t * 100).toFixed(2) + ' %'; }
        var fd = new FormData();
        fd.append('id', s.variante);
        fd.append('quantity', '1');
        fd.append('properties[Orientation]', s.orientation);
        fd.append('properties[Photo]', photo, nomJpg(s.nom));
        fd.append('properties[Recadrage]', 'x ' + cx + ' · y ' + cy + ' · ' + cw + ' × ' + ch + ' px (photo de ' + w + ' × ' + h + ' px)');
        if (apercu) fd.append('properties[_Aperçu du recadrage]', apercu, 'apercu-recadrage.jpg');
        fd.append('properties[_Recadrage en %]', 'x ' + pct(cx, w) + ' · y ' + pct(cy, h) + ' · largeur ' + pct(cw, w) + ' · hauteur ' + pct(ch, h));
        fd.append('properties[_Définition]', Math.round(s.dpi) + ' DPI');
        fd.append('properties[_Fichier client]', s.nom + ' · ' + s.natW + ' × ' + s.natH + ' px');
        fd.append('properties[_Droit de rétractation]', 'Client informé : produit personnalisé');
        envoyer(fd);
      }, 'image/jpeg', 0.85);
    });
  });

  window.addEventListener('pageshow', function () {
    s.envoi = false;
    ui.progres.hidden = true;
    majBouton();
  });

  lireChoix();
  appliquerFormat();
})();
